import { first } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { BankDetail } from '../../registration/bank-details/bankDetails';
import saveAs from 'file-saver';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
import { NULL_EXPR } from '@angular/compiler/src/output/output_ast';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.scss'],
})
export class FinanceComponent implements OnInit {
  canEditFinanceDetails: boolean = false;
  financeCalculationsForm: FormGroup;
  isSubmitted = false;
  editIcon: string = 'pi pi-fw pi-pencil';
  saveIcon: string = 'pi pi-fw pi-check';
  showFinanceComponentDialog: boolean;
  selectedFinanceComponent: any;
  selectedRowIndex: number;
  latPosition: any;
  longPosition: any;
  MIArea: any;
  canEditMIData: boolean = false;
  editBilledData: boolean = false;
  proCalculatedData: any;
  public isProDataCalculated: boolean = false;
  jeLogin = false;
  xenLogin = false;
  jeorxenLogin = false;
  public totalQuantityUsed: any;
  public inventoryDataForGrid: any;
  public inventoryRowFilteredData: any;
  public tableDataAfterModification: any = [];
  isSubmitEnable=false;
  userRole:any 
  changeActualQuantity(application, event, rowIdex) {
    // if ((Number(event.target.value) > Number(application?.BilledQuantity))) {
    //   return;
    // }
    // else {
    application.ActualQuantity = event.target.value;
    this.physicalVerficationBilledData[rowIdex] = application;
    this.physicalVerficationData.listDataForPhysicalVer =
      this.physicalVerficationBilledData;
    sessionStorage.setItem(
      'miPhysicalApplicationData',
      JSON.stringify(this.physicalVerficationData)
    );
    this.calculateTotalCostAndFarmerShare();
    // }
  }

  toggleEditFinanceDetails() {
    if (this.canEditFinanceDetails) {
      let count = 1;
      let isValid = true;
      this.physicalVerficationBilledData.forEach((data) => {
        if (
          this.greaterThan(
            Number(data.ActualQuantity),
            Number(data.BilledQuantity)
          )
        ) {
          isValid = false;
          return;
        } else {
          count++;
        }
      });
      if (isValid) {
        this.canEditFinanceDetails = !this.canEditFinanceDetails;
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Data error! Actual Quantity cant be Greater than Billed Quantity. Invalid entry at place : ' +
            count,
        });
      }
    } else {
      this.canEditFinanceDetails = !this.canEditFinanceDetails;
    }
  }

  //Bank
  fileName = 'ExcelSheet.xlsx';
  bankAccountList: BankDetail[] = [];

  bankAccount: BankDetail;

  selectedBankAccounts: BankDetail[];

  submitted: boolean;
  items: MenuItem[];

  statuses: any[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  farmerId: any;
  bankList: any;
  filteredBankList: any[];
  autoId: any;
  appId:any;
  data:any;
  physicalVerficationBilledData: any;
  physicalVerficationData: any;
  physicallyVerifiedOptions = [];
  totalCostForVerification: any;
  geolocationsarray: any = [];

  userID: any;
  ipAddress: any = '000.000.000';

  constructor(
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private cryptoJsService: CryptoJsService,
    private jeService: JEService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private vendorService: VendorDashboardService,
    private loader: AppLoaderService,
    private ipService: IpAddressService
  ) {
    const tokenData = sessionStorage.getItem('token')
      ? JSON.parse(sessionStorage.getItem('token'))
      : {};
    if (tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')) {
      this.jeLogin = true;
      this.jeorxenLogin = true;
    }
    if (tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')) {
      this.xenLogin = true;
      this.jeorxenLogin = true;
    }
  }

  ngOnInit(): void {
    this.getIP();
    this.userRole =sessionStorage.getItem('userRole')
    if (sessionStorage.getItem(this.cryptoJsService.Encrypt('canEditMIData'))) {
      this.canEditMIData = this.cryptoJsService.DecryptData(
        sessionStorage.getItem(this.cryptoJsService.Encrypt('canEditMIData'))
      );
    }
    if (
      sessionStorage.getItem(this.cryptoJsService.Encrypt('editBilledData'))
    ) {
      this.editBilledData = Boolean(
        this.cryptoJsService.DecryptData(
          sessionStorage.getItem(this.cryptoJsService.Encrypt('editBilledData'))
        )
      );
    }

    this.getGPSCoordinates();
    //Physically verified options
    this.physicallyVerifiedOptions = [
      { name: 'yes', code: 'yes' },
      { name: 'no', code: 'no' },
    ];

    this.financeCalculationsForm = this._fb.group({
      physicallyVerified: ['', Validators.required],
      remarks: ['', Validators.required],
      totalEstimateAmount: ['', Validators.required],
      transportationAmount: [0, Validators.required],
      totalBilledAmount: ['', Validators.required],
      billedTransportationAmount: ['', Validators.required],
      totalCostForPhysicalVerification: ['', Validators.required],
      totalCost: ['', Validators.required],
      maximumSubsidy: ['', Validators.required],
      farmerShare: ['', Validators.required],
      MIArea: ['', Validators.required],
      farmerInitialDeposit: ['', Validators.required],
      ChallanType: ['', Validators.required],
      SubsidyToFarmerAmount: ['', Validators.required],
      SubsidyToVendorAmount: ['', Validators.required],
      FarmerRefundAmount: ['', Validators.required],
    });

    this.route.queryParams.subscribe((params) => {
      this.autoId = this.cryptoJsService.DecryptData(params.autoId);
      this.appId = this.cryptoJsService.DecryptData(params.appId);
      this.data={autoId:this.autoId,appId:this.appId}

      if (this.autoId) {
        if (
          (sessionStorage.getItem('miPhysicalAppJEGPSCoordinates') &&
            JSON.parse(
              sessionStorage.getItem('miPhysicalAppJEGPSCoordinates')
            ) &&
            JSON.parse(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates'))
              .length > 3 &&
            this.jeLogin) ||
          !this.jeorxenLogin ||
          this.xenLogin
        ) {
          if (
            (sessionStorage.getItem('jecoordinatesVerified') &&
              sessionStorage.getItem('jecoordinatesVerified') == 'true') ||
            !this.jeorxenLogin ||
            this.xenLogin
          ) {
            if (
              (sessionStorage.getItem('miPhysicalAppXENGPSCoordinates') &&
                JSON.parse(
                  sessionStorage.getItem('miPhysicalAppXENGPSCoordinates')
                ) &&
                JSON.parse(
                  sessionStorage.getItem('miPhysicalAppXENGPSCoordinates')
                ).length > 3 &&
                this.xenLogin) ||
              !this.jeorxenLogin ||
              this.jeLogin ||
              sessionStorage.getItem('myPhysicalSurveyType') != '1'
            ) {
              if (
                (sessionStorage.getItem('xencoordinatesVerified') &&
                  sessionStorage.getItem('xencoordinatesVerified') == 'true') ||
                !this.jeorxenLogin ||
                this.jeLogin ||
                sessionStorage.getItem('myPhysicalSurveyType') != '1'
              ) {
                const jegeolocationsarray = JSON.parse(
                  sessionStorage.getItem('miPhysicalAppJEGPSCoordinates')
                );
                const xengeolocationsarray = JSON.parse(
                  sessionStorage.getItem('miPhysicalAppXENGPSCoordinates')
                );
                if (this.jeLogin) {
                  this.geolocationsarray = [...jegeolocationsarray];
                } else if (this.xenLogin) {
                  this.geolocationsarray = [...xengeolocationsarray];
                }
                if (
                  JSON.parse(
                    sessionStorage.getItem('miPhysicalApplicationData')
                  )?.AutoId == this.autoId
                ) {
                  this.physicalVerficationData = JSON.parse(
                    sessionStorage.getItem('miPhysicalApplicationData')
                  );
                  this.populateAndCalculateData(this.physicalVerficationData);
                  if (!this.editBilledData) {
                    this.proDataCalculation();
                    // this.onFinanceCalculationFormSubmit();
                  }
                } else {
                  let sessionToken = sessionStorage.getItem('token');
                  let payload = atob(
                    JSON.parse(sessionToken).authToken?.split('.')[1]
                  );
                  this.loader.start();
                  this.jeService
                    .getApplicationDataForPhysicalVerification(
                      this.autoId,
                      JSON.parse(payload)?.sub
                    )
                    .pipe(first())
                    .subscribe({
                      next: (data: any) => {
                        this.loader.close();
                        this.physicalVerficationData = data;
                        // console.log(this.physicalVerficationData,"this.physicalVerficationData1")
                        sessionStorage.setItem(
                          'miPhysicalApplicationData',
                          JSON.stringify(data)
                        );
                        this.populateAndCalculateData(data);
                        if (!this.editBilledData) {
                          this.proDataCalculation();
                          // this.onFinanceCalculationFormSubmit();
                        }
                      },
                      error: () => {
                        this.loader.close();
                        this.messageService.add({
                          severity: 'error',
                          summary: 'Error Message',
                          detail:
                            'Data error! Physical Applications not loaded.',
                        });
                      },
                    });
                }
              } else {
                this.loader.close();
                this.router.navigate(
                  [this.router.url.split('/')[1], 'application'],
                  {
                    queryParams: { autoId: params.autoId, appId: params.appId },
                  }
                );
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error Message',
                  detail: 'Captured GPS Coordinates are Not Matching',
                });
              }
            } else {
              this.loader.close();
              this.router.navigate(
                [this.router.url.split('/')[1], 'application'],
                { queryParams: { autoId: params.autoId, appId: params.appId } }
              );
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Please provide atleast 4 GPS Coordinates',
              });
            }
          } else {
            this.loader.close();
            this.router.navigate(
              [this.router.url.split('/')[1], 'application'],
              { queryParams: { autoId: params.autoId, appId: params.appId } }
            );
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Captured GPS Coordinates are Not Matching',
            });
          }
        } else {
          this.loader.close();
          this.router.navigate([this.router.url.split('/')[1], 'application'], {
            queryParams: { autoId: params.autoId, appId: params.appId },
          });
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Please provide atleast 4 GPS Coordinates',
          });
        }
      } else {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Data error! AutoID cant be empty',
        });
        return;
      }
    });
  }

  get financeCalculationFormControls() {
    return this.financeCalculationsForm.controls;
  }

  populateAndCalculateData(data) {
    this.physicalVerficationBilledData = data.listDataForPhysicalVer;
    // console.log('physicallineeeaaaaaa', this.physicalVerficationBilledData)
    //Populating the Params in Finance Calculation Form
    this.financeCalculationFormControls.totalEstimateAmount.setValue(
      data?.Estimated_Amount
    );
    this.financeCalculationFormControls.totalBilledAmount.setValue(
      data?.TotalBilledAmount
    );
    this.financeCalculationFormControls.billedTransportationAmount.setValue(
      data?.BilledTransportAmount
    );
    this.financeCalculationFormControls.MIArea.setValue(data?.MIArea);
    this.financeCalculationFormControls.farmerInitialDeposit.setValue(
      data?.FarmerShare
    );
    this.financeCalculationFormControls.ChallanType.setValue(data?.ChallanType);
    this.financeCalculationFormControls.SubsidyToFarmerAmount.setValue(
      data?.SubsidyToFarmerAmount
    );
    this.financeCalculationFormControls.SubsidyToVendorAmount.setValue(
      data?.SubsidyToVendorAmount
    );
    this.financeCalculationFormControls.FarmerRefundAmount.setValue(
      data?.FarmerRefundAmount
    );
    this.calculateTotalCostAndFarmerShare();
    this.changeMiArea();
  }

  onFinanceCalculationFormGoBack() {
    if(sessionStorage.getItem('userRole')=='DD Associate'){
      this.route.queryParams.subscribe((params) => {
        if (params.autoId) {
          this.router.navigate(
            [this.router.url.split('/')[1], 'application', 'image-attachment'],
            { queryParams: { autoId: params.autoId, appId: params.appId } }
          );
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! AutoID cant be Empty',
          });
        }
      });
    }
    else{
      this.route.queryParams.subscribe((params) => {
        if (params.autoId) {
          this.router.navigate(
            [this.router.url.split('/')[1], 'application', 'basic'],
            { queryParams: { autoId: params.autoId, appId: params.appId } }
          );
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! AutoID cant be Empty',
          });
        }
      });
    }
    
    
  }

  editFinanceComponentDialog(component: any, rowIdex) {
    component.inventory = component.inventory.map((val) => ({
      ...val,
      batchNumber_lotNo: val.batchNumber + '_' + val.lotNo,
      quantityUsed: val.QuantityUsed
        ? val.QuantityUsed
        : val.quantityUsed
        ? val.quantityUsed
        : 0,
    }));

    this.inventoryRowFilteredData = [];
    if (component?.inventory.length > 0) {
      component?.inventory.forEach((val) => {
        if (val?.QuantityUsed != 0) {
          this.inventoryRowFilteredData.push(val);
        }
      });
    }

    // console.log("productForROWEDITINVENTORY", component);

    this.submitted = false;
    this.selectedRowIndex = rowIdex;
    this.selectedFinanceComponent = { ...component };
    this.totalQuantityUsed = 0;
    // console.log(this.selectedFinanceComponent,"this.selectedFinanceComponent")
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });

    // if(this.totalQuantityUsed > 0){
    //   this.saveFinanceComponent();
    // }

    this.showFinanceComponentDialog = true;
  }

  hideFinanceComponentDialog() {
    this.showFinanceComponentDialog = false;
  }

  saveFinanceComponent() {
    if (this.selectedFinanceComponent.inventory.length > 0) {
      this.totalQuantityUsed = 0;
      this.inventoryRowFilteredData.forEach((val) => {
        this.totalQuantityUsed += val.quantityUsed;
      });

      // console.log(this.inventoryDataForGrid, 'this.inventoryDataForGrid', this.selectedFinanceComponent)
      let inventorySum = 0;
      this.selectedFinanceComponent['inventory'].forEach((val) => {
        inventorySum += val.quantityUsed;
      });

      if (this.totalQuantityUsed != inventorySum) {

        this.confirmationService.confirm({
          message: `Total input qunatity: ${inventorySum}.<pre>Total selected qunatity: ${this.totalQuantityUsed}.</pre> <pre>\bAre you sure you want to continue?</pre>`,
          accept: () => {
            // this.inventoryDataForGrid['inventory'].forEach((val) => {
            //   if (!this.inventoryRowFilteredData.includes(val)) {
            //     val.quantityUsed = 0;
            //   }
            // });
            this.submitInventoryAndCal();
          },
        });
        return;
      }
      else{
        this.submitInventoryAndCal();
      }
    } else {
      this.submitted = true;
      if (this.selectedFinanceComponent.ActualQuantity < 0) {
        return;
      }
      if (
        Number(this.selectedFinanceComponent.ActualQuantity) >
        Number(this.selectedFinanceComponent.BilledQuantity)
      ) {
        return;
      } else {
        this.physicalVerficationBilledData[this.selectedRowIndex] =
          this.selectedFinanceComponent;
        this.physicalVerficationData.listDataForPhysicalVer =
          this.physicalVerficationBilledData;
        sessionStorage.setItem(
          'miPhysicalApplicationData',
          JSON.stringify(this.physicalVerficationData)
        );
        this.calculateTotalCostAndFarmerShare();
      }
      this.showFinanceComponentDialog = false;
    }
    this.showFinanceComponentDialog = false;
  }

  submitInventoryAndCal(){
    this.inventoryDataForGrid = [this.inventoryDataForGrid].map((val) => ({
      ...val,
      filteredInventory: this.inventoryRowFilteredData,
      selectedInventory: this.inventoryRowFilteredData.map((val) => ({
        batchNumber: val?.batchNumber,
        lotNo: val?.lotNo,
        quantityUsed: val?.quantityUsed,
      })),
    }));

    // console.log(this.totalQuantityUsed,"fffffff")
    // console.log("finalllll", this.inventoryDataForGrid[0]);
    let index = this.inventoryDataForGrid[0]?.id
      ? this.inventoryDataForGrid[0]?.id
      : 0;
    if (index != null) {
      // console.log("index", index, this.inventoryDataForGrid[0])
      this.tableDataAfterModification[index] = this.inventoryDataForGrid[0];
    }
    this.physicalVerficationBilledData.forEach((e) => {
      if (
        e.inventory.length > 0 &&
        e.SizeId == this.selectedFinanceComponent.SizeId
      ) {
        e.ActualQuantity = this.totalQuantityUsed;
        e.selectedQuantity = [...this.inventoryDataForGrid];
        e.selectedInventory = [
          ...this.inventoryDataForGrid[0].selectedInventory,
        ];
      }
    });
    // console.log(this.physicalVerficationBilledData,"this.physicalVerficationBilledData11111");
    this.physicalVerficationData.listDataForPhysicalVer =
      this.physicalVerficationBilledData;
    sessionStorage.setItem(
      'miPhysicalApplicationData',
      JSON.stringify(this.physicalVerficationData)
    );
    this.calculateTotalCostAndFarmerShare();

    this.showFinanceComponentDialog = false;
  }



  greaterThan(elem1, elem2) {
    return Number(elem1) > Number(elem2);
  }

  changeMiArea() {
    // console.log('val', this.financeCalculationFormControls.MIArea.value)
    if (
      this.financeCalculationFormControls.MIArea.value >
      this.physicalVerficationData.MIArea
    ) {
      console.log('inside return');
      return;
    }
    // console.log(this.physicalVerficationBilledData[0])
    //console.log(this.physicalVerficationBilledData,"console.log(this.physicalVerficationBilledData1")
    if (
      this.physicalVerficationBilledData[0]?.ProgrammeName ==
        'Mini Sprinkler' ||
      this.physicalVerficationBilledData[0]?.ProgrammeName == 'Drip Irrigation'
    ) {
      this.financeCalculationFormControls?.transportationAmount?.setValue(
        Number(
          this.financeCalculationFormControls.MIArea.value
            ? this.financeCalculationFormControls.MIArea.value
            : 0
        ) * 2500
      );
    } else {
      this.financeCalculationFormControls?.transportationAmount?.setValue(0);
    }
    // console.log()
    this.physicalVerficationData.tempMIArea = this
      .financeCalculationFormControls.MIArea.value
      ? this.financeCalculationFormControls.MIArea.value
      : 0;
    this.physicalVerficationData.BilledTransportAmount =
      this.financeCalculationFormControls?.transportationAmount?.value;
    this.financeCalculationsForm.controls.totalCost.setValue(
      this.financeCalculationFormControls?.transportationAmount?.value +
        this.physicalVerficationData.tempTotalCost
    );
    this.totalCostForVerification = this.physicalVerficationData.tempTotalCost;
    this.financeCalculationsForm.controls.maximumSubsidy.setValue(
      parseFloat(
        (this.financeCalculationsForm.controls.totalCost.value * 0.85).toFixed(
          2
        )
      )
    );
    this.financeCalculationsForm.controls.farmerShare.setValue(
      parseFloat(
        (this.financeCalculationsForm.controls.totalCost.value * 0.15).toFixed(
          2
        )
      )
    );
    sessionStorage.setItem(
      'miPhysicalApplicationData',
      JSON.stringify(this.physicalVerficationData)
    );
  }

  calculateTotalCostAndFarmerShare() {
    let totalCost = 0;

    this.physicalVerficationBilledData.forEach((data) => {
      totalCost =
        totalCost +
        (data?.ActualQuantity
          ? Number(data?.ActualQuantity) * Number(data?.Price)
          : 0);
    });
    this.totalCostForVerification = totalCost;
    if (
      this.financeCalculationFormControls &&
      this.financeCalculationFormControls.transportationAmount &&
      this.financeCalculationFormControls.transportationAmount.value
    ) {
      totalCost =
        this.financeCalculationFormControls?.transportationAmount?.value +
        totalCost;
    }
    this.financeCalculationsForm.controls.totalCost.setValue(totalCost);
    this.physicalVerficationData.tempTotalCost = totalCost;
    sessionStorage.setItem(
      'miPhysicalApplicationData',
      JSON.stringify(this.physicalVerficationData)
    );
    this.financeCalculationsForm.controls.maximumSubsidy.setValue(
      parseFloat((totalCost * 0.85).toFixed(2))
    );
    this.financeCalculationsForm.controls.farmerShare.setValue(
      parseFloat((totalCost * 0.15).toFixed(2))
    );
  }

  onFinanceCalculationFormSubmit() {
    let components = [];
    let count = 1;
    let isValid = true;
    if(this.userRole=='DD Associate'){
      this.isSubmitEnable=true
    }
    else{
      this.isSubmitEnable=false
    }
   
    // console.log(this.physicalVerficationBilledData,"this.physicalVerficationBilledDatathis.physicalVerficationBilledData@");
    // return;
    this.physicalVerficationBilledData.forEach((data) => {
      if (data?.selectedInventory) {
        data.inventory = data.selectedInventory;
      }
      // else if(data?.inventory.length > 0){
      //   // data.inventory = data.selectedInventory;
      // }
      // else{
      //   data.inventory = data.selectedInventory;
      // }
      // if( !data.inventory){
      //   data.inventory=[]
      // }
      delete data.selectedInventory;
      delete data.selectedQuantity;
      if (Number(data.ActualQuantity) >= 0) {
        // console.log(data.inventory,"data.inventory123");
        let body = {
          compId: data.CompId,
          catId: data.CatId,
          sizeId: data.SizeId,
          actualQuantity: data.ActualQuantity,
          autoIdPriceTable: data.AutoIdPriceTable,
          inventory: data.inventory
            ? data.inventory
            : data.selectedInventory
            ? data.selectedInventory
            : [],
        };
        // if(data?.inventory.length>0){
        //   body.inventory=data.inventory;
        // }
        components.push(body);
        count++;
      } else {
        isValid = false;
        return;
      }
    });

    if (this.editBilledData) {
      if (isValid) {
        this.insertPhysicalVerification(components);
      } else {
        this.confirmationService.confirm({
          message:
            'Data error! Actual Quantity cant be null. Invalid entry at place : ' +
            count,
          header: 'Confirm',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.insertPhysicalVerification(components);
          },
        });
      }
    } else {
      this.insertPhysicalVerification(components);
    }
  }

  proDataCalculation() {
    if (
      this.greaterThan(
        this.financeCalculationFormControls.MIArea.value,
        this.physicalVerficationData.MIArea
      )
    ) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail:
          "Actual 'Area Surveyed' cannot be greater than Billed 'Area Surveyed'",
      });
      return;
    }
    const tableDataToPush: any = [];
    let count = 1;
    let isValid = true;
    this.physicalVerficationBilledData.forEach((row) => {
      if (Number(row.ActualQuantity) > 0) {
        tableDataToPush.push({
          cat: JSON.stringify(row.CatId),
          component: row.component,
          size: row.size,
          quantity: row.ActualQuantity,
          price: row.Price,
        });
        count++;
      } else {
        tableDataToPush.push({
          cat: JSON.stringify(row.CatId),
          component: row.component,
          size: row.size,
          quantity: row.ActualQuantity,
          price: row.Price,
        });
        isValid = false;
        return;
      }
    });

    let finalDataToPost = {
      estimationComponentDetail: tableDataToPush,
      programId: this.physicalVerficationData?.ProgId,
      applicationId: this.physicalVerficationData?.AppID,
      vendorId: JSON.stringify(this.physicalVerficationData?.VendorCode),
      rowSpacing: this.physicalVerficationData?.RowSpacing,
      plantSpacing: this.physicalVerficationData?.PlantSpacing,
      area: this.physicalVerficationData?.MIArea,
    };
    let reqBody = finalDataToPost;

    if (this.editBilledData) {
      if (isValid) {
        this.getMaxSubsidy(reqBody);
      } else {
        this.confirmationService.confirm({
          message:
            'Data error! Actual Quantity cant be null. Invalid entry at place : ' +
            count,
          header: 'Confirm',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.getMaxSubsidy(reqBody);
          },
        });
      }
    } else {
      this.getMaxSubsidy(reqBody);
    }
  }
  stripText(event) {
    const seperator = '^([0-9])';
    const maskSeperator = new RegExp(seperator, 'g');
    let result = maskSeperator.test(event.key);
    return result;
  }
  getMaxSubsidy(reqBody) {
    // if (
    //   JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AppID ==
    //   JSON.parse(sessionStorage.getItem('proDataCalculation'))?.AppID
    // ) {
    //   this.proCalculatedData = JSON.parse(
    //     sessionStorage.getItem('proDataCalculation')
    //   );
    //   this.isProDataCalculated = true;
    // } else {
      this.loader.start();
      this.vendorService
        .getMaxSubsidyEstimate(reqBody)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();
            this.proCalculatedData = data;
            this.isProDataCalculated = true;
            this.proCalculatedData.AppID = this.physicalVerficationData.AppID;
            sessionStorage.setItem(
              'proDataCalculation',
              JSON.stringify(this.proCalculatedData)
            );

            let MIdata = JSON.parse(
              sessionStorage.getItem('miPhysicalApplicationData')
            );
            this.populateAndCalculateData(MIdata);

            if(MIdata?.BilledTransportAmount != MIdata?.EstimatedTransportAmount){

              this.financeCalculationFormControls.totalCost.setValue(
                this.financeCalculationsForm.controls.totalBilledAmount.value + this.financeCalculationsForm.controls.billedTransportationAmount.value
              );
              this.calculateTotalCostAndFarmerShare();

              if(MIdata?.ChallanType == "Farmer Share"){
                this.financeCalculationFormControls.SubsidyToVendorAmount.setValue(
                  this.financeCalculationsForm.controls.maximumSubsidy.value
                );
              }else{
                this.financeCalculationFormControls.SubsidyToFarmerAmount.setValue(
                  this.financeCalculationsForm.controls.maximumSubsidy.value
                );
              }
              this.financeCalculationFormControls.FarmerRefundAmount.setValue(
                (MIdata.FarmerShare - this.financeCalculationsForm.controls.farmerShare.value).toFixed(2)
              );
            }
          },
          error: (err) => {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          },
          // complete: () => {
          //   this.messageService.add({
          //     severity: 'success',
          //     summary: 'Success',
          //     detail: 'Estimation Updated Successfully',
          //   });
          // },
        });
    // }
  }

  insertPhysicalVerification(compElements) {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let body = [];
    let element = {
      appID: this.physicalVerficationData?.AppID,
      vendorRegId: this.physicalVerficationData?.VendorCode,
      progID: this.physicalVerficationData?.ProgId,
      estimatedAmount: parseFloat(
        this.physicalVerficationData?.Estimated_Amount
      ),
      totalBilledAmount: parseFloat(
        this.physicalVerficationData?.TotalBilledAmount
      ),
      totalCostVerification: parseFloat(this.totalCostForVerification),
      billedTransportAmount: parseFloat(
        this.financeCalculationFormControls?.transportationAmount?.value
      ),
      maxSubsidyAmount: parseFloat(
        this.financeCalculationFormControls?.maximumSubsidy?.value
      ),
      farmerShareAmount: parseFloat(
        this.financeCalculationFormControls?.farmerShare?.value
      ),
      subsidyToFarmer_Amount: parseFloat(
        this.financeCalculationFormControls?.SubsidyToFarmerAmount?.value
      ),
      subsidyToVendor_Amount: parseFloat(
        this.financeCalculationFormControls?.SubsidyToVendorAmount?.value
      ),
      farmerRefund_Amount: parseFloat(
        this.financeCalculationFormControls?.FarmerRefundAmount?.value
      ),
      stateShare_Amount: 0,
      centerShare_Amount: 0,
      district: this.physicalVerficationData?.District,
      block: this.physicalVerficationData?.Block,
      village: this.physicalVerficationData?.Village,
      miArea: this.physicalVerficationData?.tempMIArea,
      lat: this.physicalVerficationData?.Lat
        ? this.physicalVerficationData?.Lat
        : this.latPosition,
      long: this.physicalVerficationData?.Long
        ? this.physicalVerficationData?.Long
        : this.longPosition,
      plantSpacing: this.physicalVerficationData?.PlantSpacing,
      rowSpacing: this.physicalVerficationData?.RowSpacing,
      cropID: this.physicalVerficationData?.CropId,
      landId: this.physicalVerficationData?.LandIds,
      userId: JSON.parse(payload)?.sub,
      remarks: this.financeCalculationFormControls?.remarks?.value,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
      componentDetail: compElements,
      ProData_MaxSubsidy: this.proCalculatedData.maxSubsidy,
      // listDataForPhysicalVer:this.physicalVerficationBilledData
    };
    if (this.jeorxenLogin) {
      element['insertSurveyGPSCoordiantes'] = this.geolocationsarray;
      element['surveyType'] = sessionStorage.getItem('myPhysicalSurveyType');
    }
    body.push(element);
    sessionStorage.setItem('miPhysicalAppReqBody', JSON.stringify(body));
    if (this.editBilledData) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success Message',
        detail: 'Saved!',
      });
    }
    if(sessionStorage.getItem('userRole')!=='DD Associate'){
      setTimeout(() => {
        this.route.queryParams.subscribe((params) => {
          if (params.autoId) {
            this.router.navigate(
              [this.router.url.split('/')[1], 'application', 'attachment'],
              { queryParams: { autoId: params.autoId, appId: params.appId } }
            );
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! AutoID cant be Empty',
            });
          }
        });
      }, 1000);
    }
   

    // this.jeService.insertPhysicalVerification(body).pipe(first())
    //   .subscribe({
    //     next: (data: any) => {
    //       this.messageService.add({ severity: 'success', summary: 'Success Message', detail: data });
    //       setTimeout(() => {
    //         this.route.queryParams
    //           .subscribe(params => {
    //             if (params.autoId) {
    //               this.router.navigate([this.router.url.split('/')[1], 'application', 'attachment'], { queryParams: { autoId: params.autoId, appId: params.appId } });
    //             } else {
    //               this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
    //             }
    //           }
    //           );
    //       }, 1000)
    //     },
    //     error: () => {
    //       this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Physical Verification Application not Saved.' });
    //     }
    //   });
  }

  getGPSCoordinates() {
    this._getPosition().then((pos) => {
      this.latPosition = pos.lat;
      this.longPosition = pos.lng;
    });
  }

  _getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  onInventoryRowSelect(val) {
    this.totalQuantityUsed = 0;
    // console.log(this.inventoryRowFilteredData,"this.inventoryRowFilteredData123")
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });
    // console.log(this.totalQuantityUsed ,"this.totalQuantityUsed 123")

    this.messageService.add({
      severity: 'info',
      summary: 'Row Selected',
      detail: `Total Selected Row: ${
        this.inventoryRowFilteredData?.length
          ? this.inventoryRowFilteredData?.length
          : 0
      }`,
    });
  }

  onInventoryRowUnselect(val) {
    this.totalQuantityUsed = 0;
    // console.log(this.inventoryRowFilteredData,"this.inventoryRowFilteredData456")
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });
    // console.log(this.totalQuantityUsed ,"this.totalQuantityUsed 456")

    this.messageService.add({
      severity: 'info',
      summary: 'Row Unselected',
      detail: `Total Selected Row: ${
        this.inventoryRowFilteredData?.length
          ? this.inventoryRowFilteredData?.length
          : 0
      }`,
    });
  }

  onHeaderCheckboxToggle(val) {
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });

    if (val?.checked) {
      this.messageService.add({
        severity: 'info',
        summary: 'All Row Selected',
        detail: `Total Selected Row: ${
          this.inventoryRowFilteredData?.length
            ? this.inventoryRowFilteredData?.length
            : 0
        }`,
      });
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'All Row Unselected',
        detail: `Total Selected Row: ${
          this.inventoryRowFilteredData?.length
            ? this.inventoryRowFilteredData?.length
            : 0
        }`,
      });
    }
  }

  onEditComplete(val) {
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });
  }

  submitInventoryDetails() {
    this.onCloseInventoryDialog();
    // console.log('filter', this.inventoryRowFilteredData);
    // console.log('filter', this.selectedFinanceComponent);

    this.selectedFinanceComponent = [this.inventoryDataForGrid].map((val) => ({
      ...val,
      filteredInventory: this.inventoryRowFilteredData,
      selectedInventory: this.inventoryRowFilteredData.map((val) => ({
        batchNumber: val?.batchNumber,
        lotNo: val?.lotNo,
        quantityUsed: val?.quantityUsed,
      })),
    }));

    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });
    // console.log("finalllll", this.inventoryDataForGrid[0]);

    let index = this.inventoryDataForGrid[0]?.id
      ? this.inventoryDataForGrid[0]?.id
      : 0;
    // console.log(index, '@@@')
    if (index != null) {
      // console.log("index", index, this.inventoryDataForGrid[0])
      this.tableDataAfterModification[index] = this.inventoryDataForGrid[0];
    }

    // console.log(this.tableDataAfterModification, 'finallllll1111222')
  }
  onCloseInventoryDialog() {
    // this.isOpenforEditing = false;
    this.showFinanceComponentDialog = false;
    // this.inventoryDataForGrid = null;
  }

  componentDetailsRowcolor(row) {
    if (row?.IsInventoryMandatory) {
      if (row?.inventory.length == 0) {
        return '#ff8080';
      } else {
        return '#f3cf8c';
      }
    } else if (row?.ActualQuantity) {
      return '#e6ffe6';
    } else {
      return '#ffffff';
    }
  }

  componentDetailsRowcolorMobile(row){
    if (row?.IsInventoryMandatory) {
      if (row?.inventory.length == 0) {
        return '#ff8080';
      } else {
        return '#f3cf8c';
      }
    } else if (row?.ActualQuantity) {
      return '#e6ffe6';
    } else {
      return '#eaeae1';
    }
  }
}
